module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/photos/term-bg-3-59cdc1bd5aee3db334de0335f1fbbc8d.jpg";